import React from "react";

const Interview = (props) => {
  return (
    <button className="button" onClick={props.onNext}>Next</button>
  );
};

export default Interview;
